import { useEffect, useMemo, useState } from 'react';
import { useAuthSession } from '../contexts/AuthSessionContext';
import {
  getLockedLotFilter,
  isReadOnlySession
} from '../services/authService';

/** Lock LOT filter and expose read-only flag for LOT 10 admin accounts. */
export function useLotScope(defaultValue = 'all') {
  const session = useAuthSession();
  const lockedLotFilter = useMemo(() => getLockedLotFilter(session), [session]);
  const isReadOnly = useMemo(() => isReadOnlySession(session), [session]);
  const [lotFilter, setLotFilter] = useState(() => lockedLotFilter || defaultValue);

  useEffect(() => {
    if (lockedLotFilter) setLotFilter(lockedLotFilter);
  }, [lockedLotFilter]);

  return { lotFilter, setLotFilter, lockedLotFilter, isReadOnly, session };
}
